/* AZMARA – Produktkarte: Wunschlisten-Herz bleibt nach dem Klick im gleichen Stil.
   Das Theme-Skript ersetzt beim Klick den Inhalt des Herz-Knopfs durch eigene Icons/Texte.
   Dieses Skript setzt dann wieder das eigene Herz ein und markiert gemerkte Duefte. */
(function () {
  var HEART = '<svg class="azm-heart" viewBox="0 0.67 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.7 8 3.6 4.8 6.9 4.8c2 0 3.7 1.1 5.1 3 1.4-1.9 3.1-3 5.1-3 3.3 0 5.2 3.2 4.1 6.4-1.7 4.7-9.2 9.3-9.2 9.3z"/></svg>';
  var timer = null;
  function saved() {
    try { return JSON.parse(localStorage.getItem('localWishlist')) || []; } catch (e) { return []; }
  }
  function sync() {
    var list = saved();
    var btns = document.querySelectorAll('.azm-pc__tool--wish');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var added = list.indexOf(b.getAttribute('data-handle')) !== -1;
      if (!b.querySelector('svg.azm-heart')) { b.innerHTML = HEART; }
      if (b.classList.contains('is-added') !== added) { b.classList.toggle('is-added', added); }
      b.setAttribute('aria-pressed', added ? 'true' : 'false');
    }
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 60); }
  function start() {
    sync();
    try {
      new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.azm-pc__tool--wish')) { setTimeout(sync, 450); }
    }, true);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
